var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { motion } from "framer-motion";
export default function StripHeroTextHeader(props) {
    var fields = props.fields, isPursuitSite = props.isPursuitSite;
    var TitleTag = (fields.titleTag || 'h1');
    var getProportionTextFirtsCol = function (textProportion) {
        switch (textProportion) {
            case '33-66':
                return '33';
            case '50-50':
                return '50';
            case '66-33':
                return '66';
            case '33-33':
                return '33';
            default:
                return '50';
        }
    };
    var getProportionTextSecondCol = function (textProportion) {
        switch (textProportion) {
            case '33-66':
                return '66';
            case '50-50':
                return '50';
            case '66-33':
                return '33';
            case '33-33':
                return '33';
            default:
                return '50';
        }
    };
    var backgroundStyle = {
        backgroundImage: "url(" + (fields.image ? fields.image : "") + ")",
    };
    var getTextColor = function (colours) {
        var color = colours.split('/');
        if (color[1].length > 0) {
            return color[1];
        }
        return "primary";
    };
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-hero-text-header text-"
            + ((fields.image || fields.mobileImage) ? "white media-background component component-spacing-y" : "primary")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + (isPursuitSite ? " spa-hero-text-header" : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: isPursuitSite ? "container" : "container-fluid px-0" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col position-relative" },
                    React.createElement("div", { className: "hero-text-inner row gx-0 h-align-center v-align-"
                            + (fields.verticalAlignment ? fields.verticalAlignment : "center")
                            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
                            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : ""), style: (fields.image) ? backgroundStyle : {} },
                        React.createElement("div", { className: "col" },
                            React.createElement("div", { className: "row h-100 hero-text-cols-wrapper justify-content-between v-align-bottom", itemScope: true, itemType: "https://schema.org/Thing" },
                                React.createElement("div", { className: "col col-" + (fields.columnClasses ? getProportionTextFirtsCol(fields.columnClasses) : "50") }, fields.displayTitle &&
                                    React.createElement(TitleTag, { className: fields.titleStyle ? fields.titleStyle : "h1", itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null),
                                React.createElement("div", { className: "pb-4 col col-side-right col-" + (fields.columnClasses ? getProportionTextSecondCol(fields.columnClasses) : "50") },
                                    React.createElement("div", { className: "d-flex flex-nowrap content-column justify-content-end align-items-end" },
                                        !fields.hideArrow &&
                                            React.createElement("div", { className: "button-col" },
                                                React.createElement("a", { href: fields.link ? fields.link : "#", className: "btn btn-icon mb-3 arrow arrow-" + (fields.directionArrow ? fields.directionArrow : "right"), role: "button", "aria-label": fields.linkTitle ? fields.linkTitle : "Link Title", itemProp: "url" }, fields.linkTitle &&
                                                    React.createElement("span", null, fields.linkTitle))),
                                        fields.content &&
                                            React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" }))),
                                (fields.image || fields.mobileImage) &&
                                    React.createElement("meta", { itemProp: "image", content: fields.image ? fields.image : fields.mobileImage }),
                                fields.image &&
                                    React.createElement("img", { src: fields.image, className: "img-fluid media w-100 border-radius", title: fields.displayTitle ? fields.displayTitle : "Image Title", alt: fields.image_description ? fields.image_description : "" }),
                                fields.mobileImage &&
                                    React.createElement("img", { src: fields.mobileImage, className: "img-fluid media-mobile w-100 border-radius", title: fields.displayTitle ? fields.displayTitle : "MobileImage Title", alt: fields.mobileImage_description ? fields.mobileImage_description : "" })))))))));
}
